import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=1a8c78b6"
import script from "./Verify.vue?vue&type=script&lang=ts"
export * from "./Verify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports